export const DocumentsTestIds = {
  LOAN_FORM_GENERATION_FORM_SUBMIT_BUTTON: 'loan-form-generation-form.submit-button',
  LOAN_SPECIFIC_DOCUMENTS_BROWSE_LIBRARY_BUTTON: 'loan-specific-documents.browse-library-button',
};
